import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import { v4 as uuidv4 } from 'uuid';
import SelectComp from '../../utils/Select/SelectComp';
import Images from './images/Images';
const ConfSeries = (props) => {
    const [images,setImages] = React.useState([]);
    const [formData,setFormData] = React.useState({
        seriesId: "",
        seriesName: "",
        code: uuidv4(),
        status: "Active"
    }); 

    const [err,setErr] = React.useState({
        seriesName: false,
        code: false
    })

    const [loading,setLoading] = React.useState(false) 
    React.useEffect(() => {
        if(props.type == "EDIT") { 
            setFormData({...formData,...props.series,seriesId: props.series._id})
            let seriesImage = props.series.seriesImage; 
            seriesImage = seriesImage != undefined && seriesImage != null ? seriesImage:[]; 
            setImages(seriesImage);
        } 
    },[props.series]); 
    // IMAGE
    const handleAddImage = (url) => {
        let arr = images;
        arr.push({imgUrl: url}); 
        setImages([...arr]);
    }
    const handleDeleteImage = (index) => {
        let arr = images;
        arr = arr.filter((val,i) => index != i) 
        setImages([...arr]);
    }
    // SUBMIT
    const onSubmit = () => {
        setErr({...err,seriesName: false,code: false});

        if(formData.seriesName == "") {
            setErr({...err,seriesName: "Field cannot be empty"})
        } else if(formData.code == "") {
            setErr({...err,code: "Field cannot be empty"})
        } else {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editSeries" : "/addSeries"

            axios({
                method: "post",
                url: url,
                data: {
                    ...formData,
                    seriesImage: images, 
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({seriesId: "",seriesName: "",code: uuidv4(),status: ""})
                    setImages([]);
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
        }
    }

    let btnText = props.type == "EDIT" ? "Update Series" : "Add Series";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Series Name"
                                value={formData.seriesName}
                                onBlur={(e) => setFormData({...formData,seriesName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,seriesName: e.target.value})}
                                error={err.seriesName}
                                helperText={err.seriesName}
                            />

                            <TextField 
                                variant="outlined"
                                disabled
                                className={styles.textField}
                                label="Code"
                                value={formData.series_barcode}
                                onChange={(e) => setFormData({...formData,code: e.target.value})}
                                error={err.code}
                                helperText={err.code}
                                disabled
                            /> 
                        </div> 

                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status} 
                                onChange={(e) => setFormData({...formData,status: e.target.value})}

                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            />
                        </div> 

                    </div>

                    <Divider />
                    <h2>Image</h2>
                    <Images 
                        images={images}
                        onAddImage={(url) => handleAddImage(url)}
                        onDeleteImage={(index) => handleDeleteImage(index)}
                    />
                    <Divider />
                     
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfSeries);